<template>
  <v-card v-if="schedule">
    <v-card-title class="subtitle-2">
      {{ schedule.date | dateToLongDate }} - {{ schedule.time | timeToHM }}
    </v-card-title>
    <v-card-subtitle>
      <v-row no-gutters>
        <v-col no-gutters xl="9" lg="9" md="9" sm="9" cols="9" class="subtitle-2">
        {{ (schedule.scheduledToUser) ?
            `Agendado para você` :
            `Agendado para: ${schedule.patient}`
        }}
        </v-col>
      </v-row>
    </v-card-subtitle>

    <v-card-actions>
      <v-btn text @click="contact">Contato</v-btn>
      <v-spacer></v-spacer>
      <v-btn text @click="cancel" v-if="schedule.status == 'scheduled'">Cancelar</v-btn>
    </v-card-actions>

  </v-card>
</template>

<script>
import bus from '@/plugins/eventBus';

export default {
  props: {
    value: {
      type: Object,
    },
  },
  data: () => ({
    schedule: null,
    cancelBtnLoading: false,
  }),
  created() {
    this.schedule = { ...this.value };
  },
  methods: {
    contact() {
      console.log('TODO - contact');
    },
    cancel() {
      this.cancelBtnLoading = true;
      this.$store
        .dispatch('patientSchedules/cancel', { patientId: this.schedule.patientId, scheduleId: this.schedule.id })
        .then(() => {
          bus.$emit('message', {
            message: 'Agendamento cancelado com sucesso!',
            type: 'success',
          });

          this.schedule.status = 'canceled';
          this.$emit('input', this.schedule);
        })
        .catch((err) => {
          bus.$emit('message', {
            message: err.response.data.message,
            type: 'error',
          });
        })
        .finally(() => {
          this.cancelBtnLoading = false;
        });
    },
  },
};
</script>
